export const apiUrl = "https://backend.gigsam.com/api/v1";
// export const apiUrl = "http://192.168.1.99/php_web_services/api/v1";
